module.exports = __webpack_public_path__ + "static/media/sorty-icon.a5f1b8f0.png";